(() => {
  if (customElements.get('mystic-floor-mat-u')) return;

  class MysticFloorMatU extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;

      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.videoFilters = [...this.querySelectorAll('[data-video-filter]')];
      this.videoCards = [...this.querySelectorAll('[data-video-card]')];
      this.faqFilters = [...this.querySelectorAll('[data-faq-filter]')];
      this.faqItems = [...this.querySelectorAll('[data-faq-item]')];
      this.modal = this.querySelector('[data-video-modal]');
      this.modalTitle = this.modal?.querySelector('[data-video-modal-title]');
      this.modalPlayer = this.modal?.querySelector('[data-video-modal-player]');
      this.modalClose = this.modal?.querySelector('.mystic-video-modal__close');
      this.lastVideoTrigger = null;

      this.videoFilters.forEach((button) => {
        button.addEventListener('click', () => this.filterVideos(button), { signal: this.signal });
      });

      this.videoCards.forEach((card) => {
        const trigger = card.querySelector('.mystic-video-card__media');
        trigger?.addEventListener('click', () => this.openVideo(card, trigger), { signal: this.signal });
      });

      this.faqFilters.forEach((button) => {
        button.addEventListener('click', () => this.filterFaqs(button), { signal: this.signal });
      });

      this.modal?.addEventListener('click', (event) => {
        if (!event.target.closest('[data-video-modal-close]')) return;
        event.preventDefault();
        this.closeVideo(true);
      }, { signal: this.signal });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.modal?.classList.contains('is-open')) {
          this.closeVideo(true);
        }
      }, { signal: this.signal });
    }

    disconnectedCallback() {
      this.closeVideo(false);
      this.controller?.abort();
      this.controller = null;
    }

    setActive(buttons, selected) {
      buttons.forEach((button) => {
        const active = button === selected;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    }

    filterVideos(selected) {
      const category = selected.dataset.videoFilter;
      this.setActive(this.videoFilters, selected);
      this.videoCards.forEach((card) => {
        const visible = category === 'all' || card.dataset.videoCategory === category;
        card.hidden = !visible;
        card.classList.toggle('is-hidden', !visible);
      });
    }

    filterFaqs(selected) {
      const category = selected.dataset.faqFilter;
      this.setActive(this.faqFilters, selected);
      this.faqItems.forEach((item) => {
        const visible = category === 'all' || item.dataset.faqCategory === category;
        item.hidden = !visible;
        item.classList.toggle('is-hidden', !visible);
        if (!visible) item.open = false;
      });
    }

    clearPlayer() {
      if (!this.modalPlayer) return;
      const video = this.modalPlayer.querySelector('video');
      if (video) video.pause();
      this.modalPlayer.replaceChildren();
    }

    openVideo(card, trigger) {
      const sourceUrl = card?.dataset.videoSrc;
      if (!this.modal || !this.modalPlayer || !sourceUrl) return;

      this.clearPlayer();
      this.lastVideoTrigger = trigger;

      const title = card.querySelector('h3')?.textContent?.trim() || 'MysticMats video';
      if (this.modalTitle) this.modalTitle.textContent = title;

      const player = document.createElement('video');
      player.controls = true;
      player.autoplay = true;
      player.playsInline = true;
      player.preload = 'metadata';
      player.setAttribute('aria-label', title);

      const source = document.createElement('source');
      source.src = sourceUrl;
      source.type = 'video/mp4';
      player.appendChild(source);
      this.modalPlayer.appendChild(player);

      this.modal.inert = false;
      this.modal.classList.add('is-open');
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('mystic-video-modal-lock');

      window.requestAnimationFrame(() => {
        this.modalClose?.focus();
        const playPromise = player.play();
        if (playPromise?.catch) playPromise.catch(() => {});
      });
    }

    closeVideo(restoreFocus) {
      if (!this.modal?.classList.contains('is-open')) return;

      this.modal.classList.remove('is-open');
      this.modal.setAttribute('aria-hidden', 'true');
      this.modal.inert = true;
      document.body.classList.remove('mystic-video-modal-lock');
      this.clearPlayer();

      if (restoreFocus) this.lastVideoTrigger?.focus();
      this.lastVideoTrigger = null;
    }
  }

  customElements.define('mystic-floor-mat-u', MysticFloorMatU);
})();
